<template>
  <px-custom-dialog v-model="dialog"
                    content-class="rounded-card"
                    width="1280">
    <template v-slot:activator="{ on }">
      <v-btn icon
             v-on="on">
        <v-icon>mdi-eye</v-icon>
      </v-btn>
    </template>
    <template v-slot:title>
      Aprovação de produto
    </template>
    <template>
      <px-aprovacao-solicitacao-detalhes-produto is-modal-view
                                                 :item-id-prop="itemId"
                                                 :aprovacao-id-prop="aprovacaoId"/>
    </template>
  </px-custom-dialog>
</template>

<script>
import AprovacaoSolicitacaoDetalhesProduto
  from '@/modules/aprovacao-solicitacao/detalhes-produtos/AprovacaoSolicitacaoDetalhesProduto.vue';

export default {
  props: {
    aprovacaoId: {
      type: [String, Number],
    },
    itemId: {
      type: [String, Number],
    },
  },
  data() {
    return {
      dialog: false,
    };
  },
  components: {
    pxAprovacaoSolicitacaoDetalhesProduto: AprovacaoSolicitacaoDetalhesProduto,
  },
};
</script>
